import { DownOutlined } from '@ant-design/icons';
import { useState } from 'react';
import cs from 'classnames';
import Styles from '../../../Styles.module.scss';

export default function Stop() {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={Styles.CommandCard}>
            <div className={Styles.CommandHeader} onClick={() => setExpanded(!expanded)}>
                <div>
                    <span className={Styles.CommandName}>modelpark stop</span>
                    <span className={Styles.CommandSummary}>Gracefully stop an app</span>
                </div>
                <DownOutlined className={cs(Styles.CommandExpandIcon, { [Styles.expanded]: expanded })} />
            </div>

            {expanded && (
                <div className={Styles.CommandBody}>
                    <p className={Styles.CommandDescription}>
                        Send a graceful shutdown signal (SIGTERM) to a running background app.
                        If the process does not exit within 10 seconds, a warning is printed
                        suggesting the use of <code>modelpark kill</code> instead.
                    </p>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Options</div>
                        <table className={Styles.OptionsTable}>
                            <thead>
                                <tr>
                                    <th>Flag</th>
                                    <th>Default</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>--all</td>
                                    <td>false</td>
                                    <td>Stop all running apps</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Examples</div>
                        <div className={Styles.CodeBlock} style={{ marginBottom: 8 }}>
                            <code># Stop a single app</code>
                            <br />
                            <code>modelpark stop myapp</code>
                        </div>
                        <div className={Styles.CodeBlock}>
                            <code># Stop all running apps</code>
                            <br />
                            <code>modelpark stop --all</code>
                        </div>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Output</div>
                        <div className={Styles.CodeBlock}>
                            <code>{`Stopping 'myapp' (pid 12345)... done`}</code>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
